<template>
    <div
        id="outstanding"
        class="container"
    >
        <div class="content">
            <GridModelsContainer
                :error-models="errorModels"
                :load-models="loadModels"
                :loading-models="loadingModels"
                :models="models"
            />
        </div>
    </div>
    
    
    
</template>
<script>
import ModelBox from '../Home/ModelBoxUgly'
import Spinner from "../Spinner"
import resources from "../../resources";
import EventBus from "../../eventbus";
import GridModelsContainer from "../GridModelsContainer";


export default {
    name: 'Outstanding',
    components: {ModelBox, Spinner, GridModelsContainer},
    data(){
        return {
            loadingModels: true,
            errorModels: false,
            models: null,
            currentFetchId: null,
        }
    },
    mounted(){
        this.loadModels();
        
        EventBus.$on('languageChanged', () => {
            // this.loadHomepageMovieCategories();
        });
    },
    methods: {
        loadModels(){
            this.loadingModels = true;
            this.errorModels = false;
            this.models = null;
            this.modelsCurrentPage = null;
            
            const fetchId = Math.random();
            this.currentFetchId = fetchId;
            
            resources.homepageModels.index({per_page: 56, priority: 1, page: 1, webstars: true, outstanding: true})
                .then((response) => {
                    if (fetchId !== this.currentFetchId) return;
                    this.errorModels = false;
                    this.loadingModels = false;
                    this.models = response.data.data;
                }).catch(() => {
                this.loadingModels = false;
                this.errorModels = true;
            });
        },
    },
    watch: {
        '$store.state.general.site_type': function(value) {
            this.currentFetchId = null;
            this.loadModels();
        }
    }
}
</script>
<style scoped lang="scss">
@import '../../styles/variables';

.models{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .model{
        //width: 250px;
    }
}
</style>